module.exports = __webpack_public_path__ + "img/energy-catalog.2aaf293a.webp";